import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavItem } from 'react-bootstrap';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';


export class SecureMessageNavLink extends React.Component {
  render() {
    return <NavItem as="li">
            <LinkContainer
              className="no-background-color"
              to="/secure-messages"
              data-qa-item="secureMsgIcon"
            >
            <Nav.Link className="d-inline-flex">
              <span
                className="fa-regular fa-envelope"
                aria-hidden="true"
              />
              <span className="hidden">-</span>
            {this.props.tab.badgeProperties.stateCounter > 0 ?
              <span data-qa-item="secureMsgCount" className="badge messages">
                  {this.props.tab.badgeProperties.stateCounter}
              </span> :
              null}
            </Nav.Link>
            </LinkContainer>
           </NavItem>;
  }
}

SecureMessageNavLink.propTypes = {
  tab: PropTypes.object,
};
